<template>
  <div class="tab-content" v-show="store.activeTab === 'pipeline'">
    <p class="description">Build your data pipeline from collection to AGI - manually process or build infrastructure for automation</p>
    <div class="pipeline">
      <PipelineStage :title="store.entityManager.getPipelineStageTitle('dataGeneration')" stage="dataGeneration" />
      <PipelineStage :title="store.entityManager.getPipelineStageTitle('dataProcessing')" stage="dataProcessing" />
      <PipelineStage :title="store.entityManager.getPipelineStageTitle('learning')" stage="learning" />
      <PipelineStage :title="store.entityManager.getPipelineStageTitle('consciousness')" stage="consciousness" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useGameStore } from '@/stores/gameStore';
import PipelineStage from './PipelineStage.vue';

const store = useGameStore();
</script>

<style scoped>
.description {
  color: #ccc;
  margin-bottom: 20px;
  font-style: italic;
  padding: 0 20px;
}

.pipeline {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  align-items: stretch;
}
</style>